export default __webpack_public_path__ + "static/rohitgupta-b321c1a4c05d401984a3adf684684490.jpg";